import React, { Fragment, useEffect } from 'react';
import classNames from 'classnames';
import { Pressable } from '../../shared/Pressable';
import { Footer } from '../../components/Footer';
import styles from './styles.sass';
import HermanNotFoundSVG from '../../components/svgs/HermanNotFound';
import trackEvent from '../../modules/analytics/trackEvent';

const NotFoundScreen = ({ isLoggedIn, path, handleNotFound = () => {} }) => {
  useEffect(() => {
    handleNotFound(path);
  }, []);
  return (
    <div className={styles.notFound}>
      <div className={styles.content}>
        <div className={styles.herman}>
          <HermanNotFoundSVG />
        </div>
        {isLoggedIn ? (
          <Fragment>
            <h4 className={styles.header}>
              Sorry, we couldn't find the page you were looking for. Head back
              to your dashboard instead?
            </h4>
            <a className="cyanButton linkButton" href="/dashboard">
              Go to dashboard
            </a>
          </Fragment>
        ) : (
          <Fragment>
            <h4 className={styles.header}>
              Well, this is embarrassing!
              <br />
              We couldn't find the page you were looking for&hellip;
            </h4>
            <p className={styles.copy}>
              But if you're looking to make a podcast of your own, that's
              something we can help you with.
            </p>
            <a
              className="cyanButton linkButton"
              onClick={navigateToHomepage}
              href="/"
            >
              Learn more about Anchor
            </a>
          </Fragment>
        )}
      </div>
      <Footer />
    </div>
  );

  function navigateToHomepage() {
    trackEvent(
      null,
      {
        eventCategory: '404',
        eventAction: 'Click',
        eventLabel: 'Learn more about Anchor',
      },
      { providers: [ga] }
    );
  }
};

export default NotFoundScreen;
